// GENERATED by lead1-crm-cloud-functions scripts/buildRuntimeAssets.js — DO NOT EDIT.
// Edit the sources under functions/landingPages/runtime/ and re-run npm run build:runtime-assets.
// Pure landing-component logic shared verbatim between Cloud Functions and the
// CRM preview (copied there by scripts/buildRuntimeAssets.js — edit ONLY the
// functions-repo copy). Assets (css/js strings) are injected by the callers.
const {
  resolveLanguage,
  getMicrocopy,
  getConsentDefaults,
  getFieldLabels,
} = require('./i18n');

const LANDING_COMPONENT_ATTRIBUTE = 'data-lead1-component';

const LANDING_COMPONENT_TYPES = {
  leadForm: 'lead_form',
  callbackOrCall: 'callback_or_call',
  clickToCall: 'click_to_call',
  gallery: 'gallery',
};

const SHARED_KEY = 'shared';

const COMPONENT_LABELS = {
  [LANDING_COMPONENT_TYPES.leadForm]: 'Lead Form',
  [LANDING_COMPONENT_TYPES.callbackOrCall]: 'Callback or Call',
  [LANDING_COMPONENT_TYPES.clickToCall]: 'Click to Call',
  [LANDING_COMPONENT_TYPES.gallery]: 'Gallery',
};

// Il gruppo condiviso (campi, consensi, nota privacy) ha senso solo per i
// componenti che raccolgono dati o avviano una chiamata. Una pagina con la
// sola gallery non deve pretendere una nota privacy per un carosello.
const COMPONENTS_WITH_CONSENTS = [
  LANDING_COMPONENT_TYPES.leadForm,
  LANDING_COMPONENT_TYPES.callbackOrCall,
  LANDING_COMPONENT_TYPES.clickToCall,
];

const GALLERY_ASPECT_RATIOS = ['16:9', '4:3', '3:2', '1:1'];
const DEFAULT_GALLERY_ASPECT_RATIO = '16:9';
const MAX_GALLERY_IMAGES = 20;
const GALLERY_IMAGE_FITS = ['contain', 'cover'];
const DEFAULT_GALLERY_IMAGE_FIT = 'contain';

// Mappa esplicita sulla stessa lista chiusa, non un parsing della stringa:
// un rapporto fuori lista deve dare undefined, non un NaN che si propaga.
const GALLERY_RATIO_VALUE = {
  '16:9': 16 / 9,
  '4:3': 4 / 3,
  '3:2': 3 / 2,
  '1:1': 1,
};

const REQUIRED_FIELDS = {
  [LANDING_COMPONENT_TYPES.leadForm]: [
    ['buttonLabel', 'Button Label'],
    ['successMessage', 'Success Message'],
    ['primaryColor', 'Primary Color'],
  ],
  [LANDING_COMPONENT_TYPES.callbackOrCall]: [
    ['choiceTitle', 'Choice Title'],
    ['callbackButtonLabel', 'Callback Button Label'],
    ['callButtonLabel', 'Call Button Label'],
    ['phoneNumber', 'Phone Number'],
    ['backLabel', 'Back Button Label'],
    ['successMessage', 'Success Message'],
    ['primaryColor', 'Primary Color'],
  ],
  [LANDING_COMPONENT_TYPES.clickToCall]: [
    ['phoneNumber', 'Phone Number'],
    ['title', 'Title'],
    ['buttonLabel', 'Button Label'],
    ['primaryColor', 'Primary Color'],
  ],
  // La gallery non ha campi testo obbligatori: la valida validateGalleryGroup.
  // La voce resta per non lasciare il tipo fuori dalla mappa.
  [LANDING_COMPONENT_TYPES.gallery]: [],
};

const MARKER_PATTERN = new RegExp(
  `${LANDING_COMPONENT_ATTRIBUTE}\\s*=\\s*["']([^"']+)["']`,
  'gi',
);

const MARKER_ELEMENT_PATTERN = new RegExp(
  `<([a-z][a-z0-9-]*)([^>]*\\s${LANDING_COMPONENT_ATTRIBUTE}\\s*=\\s*["']([^"']+)["'][^>]*)(?:\\/>|>[\\s\\S]*?<\\/\\1>)`,
  'gi',
);

const FIELD_NAMES = [
  'firstName',
  'lastName',
  'email',
  'zipCode',
  'birthday',
  'phone',
];

const FIELD_INPUT_TYPES = {
  firstName: 'text',
  lastName: 'text',
  email: 'email',
  zipCode: 'text',
  birthday: 'date',
  phone: 'tel',
};

const CONSENT_NAMES = [
  'marketingConsent',
  'thirdPartyConsent',
  'profilingConsent',
  'customerConsent',
  'customerConsentProfile',
];

// Chiavi del formato precedente, rimosse dai gruppi componente in normalizzazione.
const LEGACY_COMPONENT_KEYS = [
  'showFirstName',
  'showLastName',
  'showEmail',
  'firstNameLabel',
  'lastNameLabel',
  'emailLabel',
  'phoneLabel',
  'privacyUrl',
];

const LEGACY_FIELD_KEYS = {
  firstName: ['showFirstName', 'firstNameLabel'],
  lastName: ['showLastName', 'lastNameLabel'],
  email: ['showEmail', 'emailLabel'],
};

const createDefaultFields = () => ({
  firstName: { show: false, required: false, label: '' },
  lastName: { show: false, required: false, label: '' },
  email: { show: false, required: false, label: '' },
  zipCode: { show: false, required: false, label: '' },
  birthday: { show: false, required: false, label: '' },
  phone: { required: true, label: '' },
});

const createDefaultConsents = (language) => {
  const byName = getConsentDefaults(language).byName;
  return [
    { name: 'marketingConsent', text: byName.marketingConsent, required: false },
    { name: 'thirdPartyConsent', text: byName.thirdPartyConsent, required: false },
  ];
};

const createDefaultLandingComponents = () => ({
  [SHARED_KEY]: {
    language: 'en',
    fields: createDefaultFields(),
    consents: createDefaultConsents('en'),
    privacyNoteText: getConsentDefaults('en').privacyNoteText,
  },
  [LANDING_COMPONENT_TYPES.leadForm]: {
    buttonLabel: 'Send',
    successMessage: 'Thank you! We will contact you soon.',
    primaryColor: '#007eff',
  },
  [LANDING_COMPONENT_TYPES.callbackOrCall]: {
    choiceTitle: 'How do you prefer to be contacted?',
    callbackButtonLabel: 'I want to be contacted',
    callButtonLabel: 'I prefer to call directly',
    phoneNumber: '+390000000000',
    backLabel: 'Go back',
    successMessage: 'Thank you! We will contact you soon.',
    primaryColor: '#007eff',
  },
  [LANDING_COMPONENT_TYPES.clickToCall]: {
    phoneNumber: '+390000000000',
    title: 'Call us now',
    buttonLabel: 'Call now',
    primaryColor: '#007eff',
  },
  [LANDING_COMPONENT_TYPES.gallery]: {
    images: [],
    aspectRatio: DEFAULT_GALLERY_ASPECT_RATIO,
    imageFit: DEFAULT_GALLERY_IMAGE_FIT,
    backgroundColor: '#f7f9fb',
    primaryColor: '#007eff',
  },
});

const firstLegacyPrivacyUrl = (landingComponents) => {
  if (!landingComponents) return '';
  const types = Object.values(LANDING_COMPONENT_TYPES);
  for (let i = 0; i < types.length; i += 1) {
    const group = landingComponents[types[i]];
    if (group && String(group.privacyUrl || '').trim()) {
      return String(group.privacyUrl).trim();
    }
  }
  return '';
};

const normalizeFields = (fields) => {
  const stored = fields || {};
  const normalized = createDefaultFields();
  FIELD_NAMES.forEach((name) => {
    const value = stored[name] || {};
    normalized[name].label = String(value.label || '');
    if (name !== 'phone') {
      normalized[name].show = Boolean(value.show);
      normalized[name].required = Boolean(value.required);
    }
  });
  return normalized;
};

// I nomi fuori lista NON vengono scartati qui: li segnala la validazione in
// pubblicazione, così l'operatore vede un errore invece di una riga sparita.
const normalizeConsents = (consents) =>
  (Array.isArray(consents) ? consents : []).filter(Boolean).map((consent) => ({
    name: String(consent.name || ''),
    text: String(consent.text || ''),
    required: Boolean(consent.required),
  }));

// Arrotondare una frazione a 4 decimali introduce errore fino a ±5e-5. La somma
// di due frazioni arrotondate (x+w o y+h) può sforare 1.0 di fino a 1e-4. La
// tolleranza deve essere più grande di questo per evitare di scartare ritagli
// legittimi incollati al bordo destro o inferiore dell'immagine.
const CROP_EPSILON = 2e-4;

const finiteNumber = (value) =>
  typeof value === 'number' && Number.isFinite(value) ? value : null;

const positiveInteger = (value) =>
  typeof value === 'number' && Number.isInteger(value) && value > 0
    ? value
    : null;

// Il ritaglio è un'inquadratura, non un dato necessario: se arriva rotto lo si
// lascia cadere e l'immagine ricade su imageFit. Un URL non sicuro invece
// resta e lo segnala la validazione — lì è sicurezza, qui è estetica.
const toGalleryCrop = (crop) => {
  if (!crop || typeof crop !== 'object') return null;

  const x = finiteNumber(crop.x);
  const y = finiteNumber(crop.y);
  const w = finiteNumber(crop.w);
  const h = finiteNumber(crop.h);
  const iw = positiveInteger(crop.iw);
  const ih = positiveInteger(crop.ih);

  if (x === null || y === null || w === null || h === null) return null;
  if (iw === null || ih === null) return null;
  if (w <= 0 || h <= 0 || x < 0 || y < 0) return null;
  // La tolleranza vale solo sulla SOMMA, dove i due arrotondamenti si
  // accumulano. Un lato non può sforare da solo: una frazione vera <= 1
  // arrotondata a 4 decimali dà al massimo 1.0000. Quindi w o h sopra 1
  // significa dato manomesso, e lasciarlo passare farebbe uscire
  // adaptCropToRatio dall'immagine (iw - width negativo => x negativo).
  if (w > 1 || h > 1) return null;
  if (x + w > 1 + CROP_EPSILON || y + h > 1 + CROP_EPSILON) return null;
  if (GALLERY_ASPECT_RATIOS.indexOf(String(crop.ratio)) === -1) return null;

  return { x, y, w, h, ratio: String(crop.ratio), iw, ih };
};

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const roundFraction = (value) => Math.round(value * 10000) / 10000;

// Il ritaglio salvato non si riscrive MAI al cambio di rapporto: questa
// funzione ne deriva la versione buona per il rapporto corrente, e la chiamano
// allo stesso modo il render e la modale del pannello, così non divergono.
// È anche il motivo per cui il badge "da rivedere" non ha bisogno di un flag
// in Firestore: basta confrontare crop.ratio con l'aspectRatio corrente.
//
// Si mantiene la LARGHEZZA perché su uno showcase prodotto l'inquadratura
// orizzontale è quella scelta con cura; l'altezza è quasi sempre la dimensione
// con margine.
const adaptCropToRatio = (crop, targetRatio) => {
  if (!crop) return null;
  const ratioValue = GALLERY_RATIO_VALUE[targetRatio];
  if (!ratioValue || crop.ratio === targetRatio) return crop;

  const { iw, ih } = crop;
  let width = crop.w * iw;
  let height = width / ratioValue;
  // Non serve un caso simmetrico sulla larghezza: qui width > ih*ratioValue e
  // la normalizzazione garantisce width <= iw, quindi ih*ratioValue < iw e la
  // larghezza ricalcolata sta sempre dentro l'immagine. Ne segue anche che la
  // larghezza non cresce mai, si restringe o resta uguale.
  if (height > ih) {
    height = ih;
    width = ih * ratioValue;
  }

  const centerX = (crop.x + crop.w / 2) * iw;
  const centerY = (crop.y + crop.h / 2) * ih;

  return {
    x: roundFraction(clamp(centerX - width / 2, 0, iw - width) / iw),
    y: roundFraction(clamp(centerY - height / 2, 0, ih - height) / ih),
    w: roundFraction(width / iw),
    h: roundFraction(height / ih),
    ratio: targetRatio,
    iw,
    ih,
  };
};

const toGalleryImage = (image) => {
  if (typeof image === 'string') return { url: image.trim() };
  if (image && typeof image === 'object') {
    const normalized = { url: String(image.url || '').trim() };
    const crop = toGalleryCrop(image.crop);
    // La chiave si aggiunge solo se il ritaglio c'è: un'immagine senza
    // ritaglio resta { url } esatto, come si aspettano i test già scritti.
    if (crop) normalized.crop = crop;
    return normalized;
  }
  return { url: '' };
};

// Le voci senza url spariscono; quelle con un url non sicuro restano e le
// segnala la validazione, così l'operatore vede un errore invece di una riga
// svanita nel nulla.
const normalizeGalleryImages = (images) =>
  (Array.isArray(images) ? images : [])
    .map(toGalleryImage)
    .filter((image) => image.url);

// Il rapporto arriva da una select chiusa: un valore fuori lista è un
// documento manomesso, e ricadere sul default è meglio di un CSS rotto.
const normalizeAspectRatio = (value) =>
  GALLERY_ASPECT_RATIOS.indexOf(String(value)) === -1
    ? DEFAULT_GALLERY_ASPECT_RATIO
    : String(value);

// Come il rapporto: lista chiusa, e un valore fuori lista è un documento
// manomesso. `contain` è anche la resa storica, quindi un documento che non ha
// mai avuto la chiave non cambia aspetto.
const normalizeImageFit = (value) =>
  GALLERY_IMAGE_FITS.indexOf(String(value)) === -1
    ? DEFAULT_GALLERY_IMAGE_FIT
    : String(value);

const migrateFields = (stored) => {
  const fields = createDefaultFields();
  const leadForm = stored[LANDING_COMPONENT_TYPES.leadForm] || {};
  const callback = stored[LANDING_COMPONENT_TYPES.callbackOrCall] || {};

  Object.keys(LEGACY_FIELD_KEYS).forEach((name) => {
    const showKey = LEGACY_FIELD_KEYS[name][0];
    const labelKey = LEGACY_FIELD_KEYS[name][1];
    fields[name].show = Boolean(leadForm[showKey]);
    fields[name].label = String(leadForm[labelKey] || '');
  });

  fields.phone.label = String(leadForm.phoneLabel || callback.phoneLabel || '');
  return fields;
};

// Un documento legacy può non aver mai avuto questi campi (non solo averli
// vuoti): quel caso deve riprendere i default della lingua, non svuotarsi.
// Chiave assente => default; chiave presente ma vuota => resta scartata (lo
// impone il test "migration skips empty legacy consent texts").
const migrateConsents = (shared, language) => {
  const hasMarketingKey = 'consentMarketingText' in shared;
  const hasThirdPartyKey = 'consentThirdPartyText' in shared;
  if (!hasMarketingKey && !hasThirdPartyKey) {
    return createDefaultConsents(language);
  }

  const consents = [];
  const marketing = String(shared.consentMarketingText || '').trim();
  const thirdParty = String(shared.consentThirdPartyText || '').trim();
  if (marketing) {
    consents.push({ name: 'marketingConsent', text: marketing, required: false });
  }
  if (thirdParty) {
    consents.push({
      name: 'thirdPartyConsent',
      text: thirdParty,
      required: false,
    });
  }
  return consents;
};

const migratePrivacyNote = (shared, stored, language) => {
  const note = 'privacyNoteText' in shared
    ? String(shared.privacyNoteText || '').trim()
    : String(getConsentDefaults(language).privacyNoteText || '').trim();
  const url =
    String(shared.privacyUrl || '').trim() || firstLegacyPrivacyUrl(stored);
  if (!url) return note;
  return `${note} [Privacy Policy](${url})`.trim();
};

const normalizeLandingComponents = (landingComponents) => {
  const defaults = createDefaultLandingComponents();
  const stored = landingComponents || {};
  const storedShared = stored[SHARED_KEY] || {};
  // Il formato nuovo si riconosce da shared.fields: se c'è, il documento è
  // stato scritto da questa versione e i testi contengono già i link.
  const isLegacy = !storedShared.fields;
  const legacyLanguage = resolveLanguage(storedShared.language);

  const shared = {
    ...defaults[SHARED_KEY],
    ...storedShared,
    fields: isLegacy ? migrateFields(stored) : normalizeFields(storedShared.fields),
    consents: isLegacy
      ? migrateConsents(storedShared, legacyLanguage)
      : normalizeConsents(storedShared.consents),
    privacyNoteText: isLegacy
      ? migratePrivacyNote(storedShared, stored, legacyLanguage)
      : String(storedShared.privacyNoteText || ''),
  };

  delete shared.privacyUrl;
  delete shared.consentMarketingText;
  delete shared.consentThirdPartyText;

  const normalized = { [SHARED_KEY]: shared };
  Object.values(LANDING_COMPONENT_TYPES).forEach((type) => {
    const group = { ...defaults[type], ...(stored[type] || {}) };
    LEGACY_COMPONENT_KEYS.forEach((key) => delete group[key]);
    normalized[type] = group;
  });

  const gallery = normalized[LANDING_COMPONENT_TYPES.gallery];
  gallery.images = normalizeGalleryImages(gallery.images);
  gallery.aspectRatio = normalizeAspectRatio(gallery.aspectRatio);
  gallery.imageFit = normalizeImageFit(gallery.imageFit);

  return normalized;
};

const findLandingComponentMarkers = (html = '') => {
  const markers = [];
  const pattern = new RegExp(MARKER_PATTERN);
  let match = pattern.exec(html);
  while (match) {
    markers.push({ type: match[1], index: markers.length });
    match = pattern.exec(html);
  }
  return markers;
};

const validateSharedGroup = (shared) => {
  const errors = [];
  const seen = {};

  (shared.consents || []).forEach((consent, index) => {
    const label = consent.name || `#${index + 1}`;

    if (CONSENT_NAMES.indexOf(consent.name) === -1) {
      errors.push(`Consent ${label} has an unknown name.`);
    } else if (seen[consent.name]) {
      errors.push(`Consent ${consent.name} is used more than once.`);
    } else {
      seen[consent.name] = true;
    }

    if (!String(consent.text || '').trim()) {
      errors.push(`Consent ${label} requires a text.`);
    }

    findInvalidRichTextUrls(consent.text).forEach((url) =>
      errors.push(`Consent ${label} has an invalid link URL: ${url}.`),
    );
  });

  // Il testo privacy deve PORTARE all'informativa, non solo nominarla: senza
  // questo controllo una pagina pubblicherebbe con la sola prosa (o con un
  // link finto) e nessuno se ne accorgerebbe fino a un reclamo.
  if (!String(shared.privacyNoteText || '').trim()) {
    errors.push('Landing components require Privacy Note Text.');
  } else if (!hasValidRichTextLink(shared.privacyNoteText)) {
    errors.push(
      'Privacy Note Text requires a link to the privacy policy, written as [link text](https://your-domain.com/privacy).',
    );
  }

  findInvalidRichTextUrls(shared.privacyNoteText).forEach((url) =>
    errors.push(`Privacy Note Text has an invalid link URL: ${url}.`),
  );

  return errors;
};

const validateGalleryGroup = (values) => {
  const errors = [];
  const images = values.images || [];

  if (!images.length) {
    errors.push('Gallery requires at least one image.');
  }

  if (images.length > MAX_GALLERY_IMAGES) {
    errors.push(`Gallery accepts at most ${MAX_GALLERY_IMAGES} images.`);
  }

  images.forEach((image, index) => {
    if (!isSafeUrl(image.url)) {
      errors.push(`Gallery image #${index + 1} has an invalid URL.`);
    }
  });

  return errors;
};

const validateLandingComponentMarkers = ({ html = '', landingComponents }) => {
  const components = normalizeLandingComponents(landingComponents);
  const errors = [];
  const validatedTypes = new Set();
  let needsSharedGroup = false;

  findLandingComponentMarkers(html).forEach(({ type }) => {
    if (!COMPONENT_LABELS[type]) {
      errors.push(`Unknown landing component marker: ${type}.`);
      return;
    }
    if (COMPONENTS_WITH_CONSENTS.indexOf(type) !== -1) needsSharedGroup = true;
    if (validatedTypes.has(type)) return;
    validatedTypes.add(type);
    if (type === LANDING_COMPONENT_TYPES.gallery) {
      validateGalleryGroup(components[type]).forEach((error) =>
        errors.push(error),
      );
      return;
    }
    REQUIRED_FIELDS[type].forEach(([fieldName, label]) => {
      if (!String(components[type][fieldName] || '').trim()) {
        errors.push(`${COMPONENT_LABELS[type]} requires ${label}.`);
      }
    });
  });

  if (needsSharedGroup) {
    validateSharedGroup(components[SHARED_KEY]).forEach((error) =>
      errors.push(error),
    );
  }

  return errors;
};

const escapeHtml = (value) =>
  String(value === null || value === undefined ? '' : value).replace(
    /[&<>"']/g,
    (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    }[char]),
  );

const sanitizeColor = (value, fallback = '#007eff') => {
  const color = String(value || '').trim();
  return /^#[0-9a-f]{3}([0-9a-f]{3})?$/i.test(color) ? color : fallback;
};

const sanitizePhoneHref = (value, fallback = '+390000000000') => {
  const phone = String(value || '').replace(/[^\d+().\-\s]/g, '').trim();
  return phone || fallback;
};

const sanitizeUrl = (value) => {
  const url = String(value || '').trim();
  return /^(https?:\/\/|\/)/i.test(url) ? url : '#';
};

// Sintassi supportata nei testi privacy: [etichetta](url).
// L'URL non può contenere spazi né ')'.
const RICH_TEXT_LINK_PATTERN = /\[([^\]]+)\]\(([^)\s]+)\)/g;

const isSafeUrl = (value) => /^(https?:\/\/|\/)/i.test(String(value || '').trim());

// L'ordine conta: si spezza il testo GREZZO sul pattern, poi si applica
// escapeHtml alle parti di testo e all'etichetta, e sanitizeUrl all'URL.
// Fare prima l'escape trasformerebbe una '&' nell'URL in '&amp;' e
// produrrebbe link rotti.
const renderRichText = (value) => {
  const text = String(value === null || value === undefined ? '' : value);
  const pattern = new RegExp(RICH_TEXT_LINK_PATTERN);
  let result = '';
  let lastIndex = 0;
  let match = pattern.exec(text);

  while (match) {
    result += escapeHtml(text.slice(lastIndex, match.index));
    result += `<a href="${escapeHtml(sanitizeUrl(match[2]))}" target="_blank" rel="noopener noreferrer">${escapeHtml(match[1])}</a>`;
    lastIndex = match.index + match[0].length;
    match = pattern.exec(text);
  }

  return result + escapeHtml(text.slice(lastIndex));
};

const hasValidRichTextLink = (value) => {
  const text = String(value || '');
  const pattern = new RegExp(RICH_TEXT_LINK_PATTERN);
  let match = pattern.exec(text);

  while (match) {
    if (isSafeUrl(match[2])) return true;
    match = pattern.exec(text);
  }

  return false;
};

const findInvalidRichTextUrls = (value) => {
  const text = String(value || '');
  const pattern = new RegExp(RICH_TEXT_LINK_PATTERN);
  const invalid = [];
  let match = pattern.exec(text);

  while (match) {
    if (!isSafeUrl(match[2])) invalid.push(match[2]);
    match = pattern.exec(text);
  }

  return invalid;
};

const getRuntimeValue = (runtime, key, fallback) =>
  runtime && runtime[key] ? runtime[key] : fallback;

const buildConfigJson = ({ type, shared, runtime }) =>
  JSON.stringify({
    type,
    campaignId: getRuntimeValue(runtime, 'campaignId', '__CAMPAIGN_ID__'),
    countryId: getRuntimeValue(runtime, 'countryId', '__COUNTRY_ID__'),
    endpoint: getRuntimeValue(runtime, 'crmEndpoint', '__CRM_ENDPOINT__'),
    i18n: getMicrocopy(shared.language),
  }).replace(/</g, '\\u003c');

const renderConfigScript = (config) =>
  `<script type="application/json" data-l1-config>${config}</script>`;

const renderInput = ({ id, label, name, type, required }) =>
  `<div class="l1c-field"><label class="l1c-label" for="${id}_${name}">${escapeHtml(label)}</label><input class="l1c-input" id="${id}_${name}" type="${type}" name="${name}"${required ? ' required' : ''} /></div>`;

const renderHoneypot = () =>
  '<div class="l1c-hp" aria-hidden="true"><input type="text" name="website" tabindex="-1" autocomplete="off" /></div>';

const CONSENT_CHECK_SVG =
  '<span class="l1c-check"><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M5 10.5l3.5 3.5L15 7"/></svg></span>';

const renderConsentFields = (shared, id) => {
  const checkboxes = (shared.consents || [])
    .map((consent, index) => {
      const inputId = `${id}_c${index}`;
      const required = consent.required ? ' data-l1-required="1"' : '';
      return `<div class="l1c-consent"><input type="checkbox" name="${escapeHtml(consent.name)}" id="${inputId}"${required} />${CONSENT_CHECK_SVG}<label for="${inputId}">${renderRichText(consent.text)}</label></div>`;
    })
    .join('');

  return `<div class="l1c-consents">${checkboxes}<p class="l1c-privacy-note">${renderRichText(shared.privacyNoteText)}</p></div>`;
};

const renderSubmitButton = (label) =>
  `<button type="submit" class="l1c-btn l1c-btn-primary"><span class="l1c-btn-label">${escapeHtml(label)}</span><span class="l1c-spinner" hidden></span></button><p class="l1c-form-error" hidden></p>`;

const renderSuccess = (message) =>
  `<div class="l1c-success" hidden><svg class="l1c-success-icon" viewBox="0 0 56 56" aria-hidden="true"><circle cx="28" cy="28" r="26"/><path d="M16 29l8 8 16-16"/></svg><p>${escapeHtml(message)}</p></div>`;

// `rootClass`, `style` e `card` servono alla gallery: root a larghezza piena,
// variabili CSS aggiuntive e nessuna card attorno. Gli altri tre componenti
// non passano nulla e ottengono il comportamento di prima.
const renderWrapper = ({
  id,
  type,
  color,
  inner,
  configJson,
  rootClass = '',
  style = '',
  card = true,
}) => {
  const classes = rootClass ? `l1c ${rootClass}` : 'l1c';
  const vars = `--l1-primary:${color}${style ? `;${style}` : ''}`;
  const body = card ? `<div class="l1c-card">${inner}</div>` : inner;
  return `<div class="${classes}" id="${id}" data-l1-type="${type}" style="${vars}">${body}${renderConfigScript(configJson)}</div>`;
};

const renderFields = ({ fields, language, id }) => {
  const labels = getFieldLabels(language);
  return FIELD_NAMES.filter((name) => name === 'phone' || fields[name].show)
    .map((name) =>
      renderInput({
        id,
        label: fields[name].label || labels[name],
        name,
        type: FIELD_INPUT_TYPES[name],
        required: name === 'phone' ? true : fields[name].required,
      }),
    )
    .join('');
};

const GALLERY_RATIO_PADDING = {
  '16:9': '56.25%',
  '4:3': '75%',
  '3:2': '66.6667%',
  '1:1': '100%',
};

const GALLERY_ARROW_SVG =
  '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';

const GALLERY_CLOSE_SVG =
  '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

// I quattro numeri finiscono in un attributo style: passano da un cast
// numerico esplicito, non da escapeHtml di una stringa arbitraria. È la stessa
// ragione per cui i colori passano da sanitizeColor e i rapporti da una lista
// chiusa. Un valore che non supera il cast fa cadere l'intero ritaglio e
// l'immagine torna a imageFit.
const CROP_VAR_KEYS = ['x', 'y', 'w', 'h'];

const cropStyleVars = (crop) => {
  if (!crop) return '';
  const parts = [];
  for (let i = 0; i < CROP_VAR_KEYS.length; i += 1) {
    const value = Number(crop[CROP_VAR_KEYS[i]]);
    if (!Number.isFinite(value)) return '';
    parts.push(`--l1-crop-${CROP_VAR_KEYS[i]}:${value.toFixed(4)}`);
  }
  return parts.join(';');
};

// La prima slide è quasi sempre sopra la piega: parte subito e con priorità,
// le altre aspettano. Le copie nel lightbox sono tutte lazy, così finché
// nessuno apre lo zoom non scaricano nulla.
const renderGallerySlides = ({ images, microcopy, ratio }) =>
  images
    .map((image, index) => {
      const loading =
        index === 0
          ? ' loading="eager" fetchpriority="high"'
          : ' loading="lazy"';
      const label = `${microcopy.galleryZoom} — ${index + 1} / ${images.length}`;
      const vars = cropStyleVars(adaptCropToRatio(image.crop, ratio));
      const cropped = vars ? ' is-cropped' : '';
      const style = vars ? ` style="${vars}"` : '';
      return `<button type="button" class="l1c-slide${cropped}" data-l1-zoom="${index}" aria-label="${escapeHtml(label)}"${style}><img src="${escapeHtml(image.url)}" alt="" decoding="async"${loading} /></button>`;
    })
    .join('');

const renderGalleryNav = (microcopy) =>
  [
    `<button type="button" class="l1c-gnav is-prev" data-l1-step="-1" aria-label="${escapeHtml(microcopy.galleryPrev)}">${GALLERY_ARROW_SVG}</button>`,
    `<button type="button" class="l1c-gnav is-next" data-l1-step="1" aria-label="${escapeHtml(microcopy.galleryNext)}">${GALLERY_ARROW_SVG}</button>`,
  ].join('');

const renderGalleryDots = (images) =>
  `<div class="l1c-dots">${images
    .map(
      (image, index) =>
        `<button type="button" class="l1c-dot${index === 0 ? ' is-active' : ''}" data-l1-goto-slide="${index}" aria-label="${index + 1} / ${images.length}"></button>`,
    )
    .join('')}</div>`;

// Il lightbox riusa lo stesso track scroll-snap del carosello: lo swipe resta
// nativo e prev/next è la stessa funzione. Le variabili CSS sono ripetute
// inline perché a runtime il nodo viene spostato su document.body e uscirebbe
// dallo scope di .l1c.
const renderGalleryLightbox = ({ images, microcopy, vars }) => {
  const multi = images.length > 1;
  const slides = images
    .map(
      (image) =>
        `<div class="l1c-lb-slide"><img src="${escapeHtml(image.url)}" alt="" decoding="async" loading="lazy" /></div>`,
    )
    .join('');

  return [
    `<div class="l1c-lb" data-l1-lightbox hidden role="dialog" aria-modal="true" aria-label="${escapeHtml(microcopy.galleryLabel)}" style="${vars}">`,
    `<div class="l1c-lb-track" data-l1-track>${slides}</div>`,
    `<button type="button" class="l1c-lb-close" data-l1-lb-close aria-label="${escapeHtml(microcopy.galleryClose)}">${GALLERY_CLOSE_SVG}</button>`,
    multi ? renderGalleryNav(microcopy) : '',
    multi
      ? `<p class="l1c-lb-counter" data-l1-lb-counter>1 / ${images.length}</p>`
      : '',
    '</div>',
  ].join('');
};

const renderGallery = ({ values, shared, id, configJson }) => {
  const images = values.images || [];
  // Non dovrebbe accadere: la validazione blocca la pubblicazione. Ma un
  // placeholder tratteggiato in pagina pubblicata sarebbe peggio del nulla.
  if (!images.length) return '';

  const microcopy = getMicrocopy(shared.language);
  const ratio = GALLERY_RATIO_PADDING[values.aspectRatio]
    ? values.aspectRatio
    : '16:9';
  const color = sanitizeColor(values.primaryColor);
  const extraVars = [
    `--l1-gal-bg:${sanitizeColor(values.backgroundColor, '#f7f9fb')}`,
    `--l1-gal-ratio:${ratio.replace(':', '/')}`,
    `--l1-gal-pad:${GALLERY_RATIO_PADDING[ratio]}`,
    `--l1-gal-fit:${normalizeImageFit(values.imageFit)}`,
  ].join(';');

  const inner = [
    '<div class="l1c-gallery">',
    `<div class="l1c-track" data-l1-track tabindex="0" role="group" aria-roledescription="${escapeHtml(microcopy.galleryRoleDescription)}" aria-label="${escapeHtml(microcopy.galleryLabel)}">`,
    renderGallerySlides({ images, microcopy, ratio }),
    '</div>',
    images.length > 1 ? renderGalleryNav(microcopy) : '',
    images.length > 1 ? renderGalleryDots(images) : '',
    '</div>',
    renderGalleryLightbox({
      images,
      microcopy,
      vars: `--l1-primary:${color};${extraVars}`,
    }),
  ].join('');

  return renderWrapper({
    id,
    type: LANDING_COMPONENT_TYPES.gallery,
    color,
    inner,
    configJson,
    rootClass: 'l1c-gallery-root',
    style: extraVars,
    card: false,
  });
};

const renderLeadForm = ({ values, shared, id, configJson }) => {
  const inner = [
    '<div data-l1-view="form"><form novalidate>',
    renderHoneypot(),
    renderFields({ fields: shared.fields, language: shared.language, id }),
    renderConsentFields(shared, id),
    renderSubmitButton(values.buttonLabel || 'Send'),
    '</form></div>',
    renderSuccess(values.successMessage),
  ].join('');

  return renderWrapper({
    id,
    type: LANDING_COMPONENT_TYPES.leadForm,
    color: sanitizeColor(values.primaryColor),
    inner,
    configJson,
  });
};

const renderCallbackOrCall = ({ values, shared, id, configJson }) => {
  const phoneNumber = sanitizePhoneHref(values.phoneNumber);
  const backButton = `<button type="button" class="l1c-btn l1c-btn-back" data-l1-goto="choice">${escapeHtml(values.backLabel)}</button>`;

  const inner = [
    '<div class="l1c-steps" data-l1-view="steps">',
    '<div class="l1c-step" data-l1-step="choice">',
    `<p class="l1c-title">${escapeHtml(values.choiceTitle)}</p>`,
    `<button type="button" class="l1c-btn l1c-btn-primary" data-l1-goto="callback">${escapeHtml(values.callbackButtonLabel)}</button>`,
    `<button type="button" class="l1c-btn l1c-btn-outline" data-l1-goto="call">${escapeHtml(values.callButtonLabel)}</button>`,
    '</div>',
    '<div class="l1c-step" data-l1-step="callback" hidden><form novalidate>',
    renderHoneypot(),
    renderFields({ fields: shared.fields, language: shared.language, id }),
    renderConsentFields(shared, id),
    renderSubmitButton(values.callbackButtonLabel),
    '</form>',
    backButton,
    '</div>',
    '<div class="l1c-step" data-l1-step="call" hidden>',
    renderConsentFields(shared, `${id}_call`),
    `<a href="tel:${escapeHtml(phoneNumber)}" class="l1c-btn l1c-btn-primary">${escapeHtml(values.callButtonLabel)}</a>`,
    backButton,
    '</div>',
    '</div>',
    renderSuccess(values.successMessage),
  ].join('');

  return renderWrapper({
    id,
    type: LANDING_COMPONENT_TYPES.callbackOrCall,
    color: sanitizeColor(values.primaryColor),
    inner,
    configJson,
  });
};

const renderClickToCall = ({ values, shared, id, configJson }) => {
  const phoneNumber = sanitizePhoneHref(values.phoneNumber);
  const inner = [
    `<p class="l1c-title">${escapeHtml(values.title)}</p>`,
    renderConsentFields(shared, id),
    `<a href="tel:${escapeHtml(phoneNumber)}" class="l1c-btn l1c-btn-primary">${escapeHtml(values.buttonLabel)}</a>`,
  ].join('');

  return renderWrapper({
    id,
    type: LANDING_COMPONENT_TYPES.clickToCall,
    color: sanitizeColor(values.primaryColor),
    inner,
    configJson,
  });
};

const RENDERERS = {
  [LANDING_COMPONENT_TYPES.leadForm]: renderLeadForm,
  [LANDING_COMPONENT_TYPES.callbackOrCall]: renderCallbackOrCall,
  [LANDING_COMPONENT_TYPES.clickToCall]: renderClickToCall,
  [LANDING_COMPONENT_TYPES.gallery]: renderGallery,
};

const ID_PREFIXES = {
  [LANDING_COMPONENT_TYPES.leadForm]: 'lead1_lf',
  [LANDING_COMPONENT_TYPES.callbackOrCall]: 'lead1_cc',
  [LANDING_COMPONENT_TYPES.clickToCall]: 'lead1_ctc',
  [LANDING_COMPONENT_TYPES.gallery]: 'lead1_gl',
};

const renderAssets = (assets) => {
  if (!assets || !assets.css || !assets.js) {
    throw new Error('Landing runtime assets are required to transform markers');
  }
  const css = String(assets.css).replace(/<\/style/gi, '<\\/style');
  const js = String(assets.js).replace(/<\/script/gi, '<\\/script');
  return `<style>${css}</style><script>${js}</script>`;
};

const transformLandingComponentMarkers = ({
  html = '',
  landingComponents,
  runtime,
  assets,
}) => {
  const components = normalizeLandingComponents(landingComponents);
  const shared = components[SHARED_KEY];
  let index = 0;
  let assetsInjected = false;

  return html.replace(MARKER_ELEMENT_PATTERN, (match, tagName, attrs, type) => {
    if (!RENDERERS[type]) return match;

    const configJson = buildConfigJson({ type, shared, runtime });
    const componentHtml = RENDERERS[type]({
      values: components[type],
      shared,
      id: `${ID_PREFIXES[type]}_${index}`,
      configJson,
    });
    index += 1;

    if (assetsInjected) return componentHtml;
    assetsInjected = true;
    return renderAssets(assets) + componentHtml;
  });
};

module.exports = {
  LANDING_COMPONENT_ATTRIBUTE,
  LANDING_COMPONENT_TYPES,
  SHARED_KEY,
  COMPONENT_LABELS,
  COMPONENTS_WITH_CONSENTS,
  FIELD_NAMES,
  FIELD_INPUT_TYPES,
  CONSENT_NAMES,
  GALLERY_ASPECT_RATIOS,
  GALLERY_IMAGE_FITS,
  GALLERY_RATIO_VALUE,
  MAX_GALLERY_IMAGES,
  createDefaultLandingComponents,
  normalizeLandingComponents,
  findLandingComponentMarkers,
  validateLandingComponentMarkers,
  transformLandingComponentMarkers,
  resolveLanguage,
  renderRichText,
  findInvalidRichTextUrls,
  adaptCropToRatio,
};
